/**
 * @name HelpTooltip
 * @description Componente con icono y tooltip de ayuda para el usuario
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';

import { Icons, Theme } from '@styles';

// Material-UI
import Tooltip from '@material-ui/core/Tooltip';

const MuiTooltip = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <Tooltip
      enterDelay={100}
      leaveDelay={200}
      PopperProps={{
        modifiers: { computeStyle: { gpuAcceleration: false } }
      }}
      {...restProps}
    >
      <span style={{ display: 'flex' }}>
        {children}
      </span>
    </Tooltip>
  );
};

MuiTooltip.propTypes = {
  // Tooltip reference element.
  children: PropTypes.node.isRequired,
};

const StyledTooltip = withStyles(() => ({
  tooltip: {
    fontFamily: 'Bryant Pro Regular',
    fontSize: Theme.typography.smallText,
    color: Theme.colors.white,
    backgroundColor: Theme.colors.greyDark,
    boxShadow: Theme.shadows.depth1,
    margin: '8px 0',
  },
  popper: {
    willChange: 'auto !important'
  }
}))(MuiTooltip);


const HelpTooltip = (props) => {
  const { message } = props;

  return (
    <>
      <StyledTooltip title={message}>
        <Styled.HelpIcon />
      </StyledTooltip>
    </>
  );
};

HelpTooltip.propTypes = {
  // Mensaje que se muestra en el tooltip.
  message: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired
  ])
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.HelpIcon = styled(Icons.Help)`
  font-size: 20px;
`;

export default HelpTooltip;
